import produce from "immer"
import { ASC } from "const"
import { MtStudySession } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initStudySession: MtStudySession = {
    id: null,
    projectId: null,
    studyId: null,
    date: null,
    startTime: "",
    endTime: "",
    facilitatorId: null,
    scribeId: null,
    comment: "",
}

const initStudySessionState: types.StudySessionState = {
    baseRoute: null,

    sessionList: {},
    sessionListByStudy: {},
    sessionIds: [],
    sessionView: initStudySession,
    sessionEdit: initStudySession,

    sessionAttendance: {},

    sortColumn: "date",
    sortOrder: ASC,
    filters: {
        search: null,
    },

    reloadList: true,
    reloadView: true,
    reloadEdit: true,
}

const studySessionReducer = produce((
    draft: types.StudySessionState = initStudySessionState,
    action: ActionTypes = null,
): types.StudySessionState => {
    switch (action.type) {
        case types.STUDY_SESSION_BASE_ROUTE:
            draft.baseRoute = action.baseRoute
            return draft

        case types.STUDY_SESSION_LIST:
            draft.sessionList = action.sessionList
            return draft

        case types.STUDY_SESSION_LIST_BY_STUDY:
            draft.sessionListByStudy = action.sessionListByStudy
            return draft

        case types.STUDY_SESSION_IDS:
            draft.sessionIds = action.sessionIds
            return draft

        case types.STUDY_SESSION_VIEW:
            draft.sessionView = action.session
            return draft

        case types.STUDY_SESSION_EDIT:
            draft.sessionEdit = action.session
            return draft

        case types.STUDY_SESSION_ATTENDANCE:
            draft.sessionAttendance = action.sessionAttendance
            return draft

        case types.STUDY_SESSION_SORT:
            draft.sortColumn = action.sortColumn
            draft.sortOrder = action.sortOrder
            return draft

        case types.STUDY_SESSION_FILTERS:
            draft.filters = action.filters
            return draft

        case types.STUDY_SESSION_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.STUDY_SESSION_RELOAD_VIEW:
            draft.reloadView = action.value
            return draft

        case types.STUDY_SESSION_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default studySessionReducer
